
$(document).ready(function() {
    function moveContact(width) {
        if (width < 992) {
            $("#contact-desktop-section .container-section").appendTo("#contact-mobile-section .container-fluid")
            $('.contactbox1').css("margin-bottom", "0")
        } else {
            $("#contact-mobile-section .container-section").prependTo("#contact-desktop-section")
            $('.contactbox1').css("margin-bottom", "30px")
        }
    }
    $('.modallocation .modal-body .mloc').on('click',function(){
        $('.modallocation .modal-body .mloc').removeClass('actvv');
        $(this).addClass('actvv');
    });

    let width = $(window).width()
    moveContact(width)

    $(window).resize(function () {
        let width = $(window).width()
        moveContact(width)
    });

    $("body").on("click", "#call-button", function (e) {
        if($("#call-dropdown").children().length > 1) {
            e.preventDefault()
            $("#call-dropdown").insertBefore(this)
            $("#call-dropdown").toggleClass("hidden")
        }
    });

});